import { useEffect, useState } from "react";
import Upiimg from '../assets/images/upipng.png'
import Net from '../assets/images/netBankingpng.png'
import Qr from '../assets/images/qur.png'
import TetherImg from '../assets/images/Tether.png';
import { Link, useNavigate } from "react-router-dom";

function Upi() {
    const [progress, setProgress] = useState<number>(0);

    useEffect(() => {
        // Simulate a process that updates progress
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 10;
            });
        }, 100); // Increase progress by 10 every second

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    // Default selected option and image
    const [selectedOption, setSelectedOption] = useState<string>('option1');
    const [selectedImage, setSelectedImage] = useState<string>(Upiimg);

    // This effect is used to set the default values when the component mounts
    useEffect(() => {
        setSelectedOption('option1');
        setSelectedImage(Upiimg);
    }, []);

    const handleSelectOption = (value: string, imageSrc: string) => {
        setSelectedOption(value);
        setSelectedImage(imageSrc);
    };

    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1); // Go back to the previous page
    };

    return (
        <section>
            <div className="container">
                <div className="row">
                    <div className="col-12 p-0">
                        <button className="backPayment" onClick={goBack}>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 42 42" fill="none">
                                    <path d="M18.9497 21.0012L27.6119 29.6632L25.137 32.138L14 21.0012L25.137 9.86426L27.6119 12.3391L18.9497 21.0012Z" fill="white" />
                                </svg>
                            </span>
                            Back
                        </button>
                    </div>
                </div>
            </div>
            <div className="container upiScreen">
                <div className="row upiScreenSelectedMethod depositWe">
                    <div className='depWithdrawal p-0'>
                        <Link to="/deposit">
                            <button className='active'>Deposit</button>
                        </Link>
                        <Link to="/Withdrawal">
                            <button>Withdrawal</button>
                        </Link>
                    </div>
                    <label className="dropdownLabel p-0">Selected Method</label>
                    <div className="dropdown p-0">
                        {/* Button with the selected option and image */}
                        <button
                            className="btn btn-primary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            {selectedImage && (
                                <img
                                    src={selectedImage}
                                    alt="Selected Option"
                                    style={{ width: 20, height: 20, marginRight: '8px' }}
                                />
                            )}
                            {selectedOption === 'option1'
                                ? 'Upi'
                                : selectedOption === 'option2'
                                    ? 'Bank'
                                    : selectedOption === 'option3'
                                        ? 'Qr'
                                        : 'Tether'}

                        </button>
                        <ul className="dropdown-menu">
                            {/* Dropdown Item 1 */}
                            <li onClick={() => handleSelectOption('option1', Upiimg)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={Upiimg}
                                        alt="Option 1"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    UPI
                                </a>
                            </li>
                            {/* Dropdown Item 2 */}
                            <li onClick={() => handleSelectOption('option2', Net)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={Net}
                                        alt="Option 2"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    Bank
                                </a>
                            </li>
                            {/* Dropdown Item 3 */}
                            <li onClick={() => handleSelectOption('option3', Qr)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={Qr}
                                        alt="Option 3"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    QR
                                </a>
                            </li>
                            <li onClick={() => handleSelectOption('option4', TetherImg)}>
                                <a className="dropdown-item" href="#">
                                    <img
                                        src={TetherImg}
                                        alt="Option 3"
                                        className="me-2"
                                        style={{ width: 20, height: 20 }}
                                    />
                                    Tether
                                </a>
                            </li>
                        </ul>
                    </div>
                    {/* {selectedOption === 'option1' && (
                       <p></p>
                    )}

                    {selectedOption === 'option2' && (
                        <p></p>
                    )}

                    {selectedOption === 'option3' && (
                        <p></p>
                    )}
                    {selectedOption === 'option4' && (
                        <p></p>
                    )} */}
                </div>
                <div className="row">
                    <div className="col-12 screenShotSec mt-2">
                        <div className="row">
                            <div className="col-x-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                <label className="mt-0">Amount Payable <sup style={{ color: '#F75653' }}>*</sup></label>
                                <input className="trxId" type="text" placeholder='₹100' />
                            </div>
                            <div className="col-x-6 col-lg-6 col-md-6 col-sm-12 col-12 my-mb">
                                <label>UPI Id </label>
                                <div className="inputBank">
                                    <input className="trxId m-0 p-0" type="text" placeholder='hdfc@upi128' />
                                    <button style={{ width: 'auto', margin: 0, padding: 0 }}>
                                        <svg height="20" viewBox="0 0 24 24" width="24" fill="#94A3B8" xmlns="http://www.w3.org/2000/svg"><path d="M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z" /><path d="M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z" /></svg>
                                    </button>
                                </div>
                            </div>
                            <div className="col-12 my-mb">
                                <label>Submit UTR Manually <sup style={{ color: '#F75653' }}>*</sup></label>
                                <input className="trxId" type="text" placeholder='Enter UTR (12 digit UPI Request' />
                            </div>
                            <label className="mt-2">Upload Transaction Screenshot <sup style={{ color: '#F75653' }}>*</sup></label>
                            <div className="uplodScreenBtn">
                                <svg width="80" height="70" viewBox="0 0 90 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="89.8876" height="80" rx="3.59551" fill="#314A55" fillOpacity="0.78" />
                                    <rect x="0.449438" y="0.449438" width="88.9888" height="79.1011" rx="3.14607" stroke="#F8F8F8" strokeOpacity="0.1" strokeWidth="0.898876" strokeDasharray="3.8 3.8" />
                                    <g opacity="0.2">
                                        <path d="M66.6693 13.7528H23.3337C19.8406 13.7528 17 16.5924 17 20.0897V59.9177C17 63.4108 19.8406 66.2475 23.3337 66.2475H66.6691C70.1622 66.2475 72.9998 63.4108 72.9998 59.9177V20.0897C73 16.5924 70.1624 13.7528 66.6693 13.7528ZM53.2124 23.177C56.5905 23.177 59.33 25.9167 59.33 29.2945C59.33 32.6724 56.5903 35.4121 53.2124 35.4121C49.8335 35.4121 47.0949 32.6724 47.0949 29.2945C47.0949 25.9167 49.8335 23.177 53.2124 23.177ZM64.683 60.3927H26.1929C24.5033 60.3927 23.7508 59.1703 24.5125 57.6622L35.0114 36.8672C35.7721 35.3593 37.2219 35.2247 38.2486 36.5663L48.8056 50.3626C49.8323 51.7045 51.6269 51.8186 52.8147 50.6165L55.3973 48.0012C56.5841 46.799 58.3327 46.9479 59.3013 48.3315L65.989 57.8843C66.9557 59.27 66.3725 60.3927 64.683 60.3927Z" fill="white" />
                                    </g>
                                </svg>
                                <div className="ms-3">
                                    <h6>
                                        <svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                            <g clipPath="url(#clip0_683_5092)">
                                                <path d="M13.9899 13.9899L10.4924 10.4924L6.99496 13.9899" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M10.4922 10.4924V18.3618" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M17.8284 16.0796C18.6812 15.6147 19.3549 14.879 19.7431 13.9887C20.1314 13.0984 20.2121 12.1041 19.9725 11.1628C19.7329 10.2215 19.1867 9.38679 18.42 8.79041C17.6534 8.19404 16.7099 7.86995 15.7386 7.86931H14.6369C14.3722 6.84564 13.879 5.89528 13.1942 5.08969C12.5093 4.28409 11.6508 3.64423 10.6831 3.2182C9.71539 2.79217 8.6637 2.59106 7.60708 2.62999C6.55046 2.66892 5.51642 2.94687 4.58269 3.44296C3.64896 3.93905 2.83984 4.64036 2.21616 5.49416C1.59248 6.34796 1.17048 7.33204 0.981866 8.37242C0.793256 9.41279 0.842951 10.4824 1.12722 11.5008C1.41148 12.5192 1.92292 13.4599 2.62308 14.2522" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M13.9899 13.9899L10.4924 10.4924L6.99496 13.9899" stroke="white" strokeWidth="1.00889" strokeLinecap="round" strokeLinejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_683_5092">
                                                    <rect width="20.9849" height="20.9849" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        Select and Uplaod files
                                    </h6>
                                    <p>Supported formates: JPEG, PNG, JPEG, PDF</p>
                                </div>
                                <input type="file" style={{ opacity: '0' }} />
                            </div>
                            <div className="col-12">
                                <button>DEPOSIT</button>
                            </div>
                            {/* <div>
                            <div className="uplodFile">
                                <p>your-file-here.PDF</p>
                                <div className="d-flex">
                                    <button>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M8 16C5.87833 16 3.84331 15.1571 2.34315 13.6568C0.842901 12.1565 0 10.1217 0 8C0 5.87833 0.842901 3.84332 2.34315 2.34315C3.84353 0.842902 5.87833 0 8 0C10.1217 0 12.1567 0.842902 13.6568 2.34315C15.1571 3.84353 16 5.87833 16 8C15.9974 10.121 15.1538 12.1545 13.654 13.654C12.1543 15.1538 10.1207 15.9974 8 16ZM11.0851 5.94242V5.9423C11.2254 5.80678 11.3053 5.62063 11.3071 5.42558C11.3088 5.23053 11.2321 5.04292 11.0941 4.90496C10.9562 4.76701 10.7685 4.69031 10.5735 4.69202C10.3784 4.69372 10.1923 4.77371 10.0568 4.91397L8 6.97149L5.94323 4.91397C5.75853 4.7356 5.49346 4.66779 5.2457 4.73572C4.99805 4.80366 4.8046 4.99713 4.73665 5.24477C4.66871 5.49254 4.73653 5.7576 4.9149 5.9423L6.97167 7.99983L4.9149 10.0573C4.77464 10.1929 4.69465 10.379 4.69294 10.5741C4.69124 10.7691 4.76794 10.9567 4.90589 11.0947C5.04383 11.2326 5.23145 11.3093 5.4265 11.3076C5.62155 11.3059 5.8077 11.2259 5.94322 11.0857L7.99999 9.02815L10.0568 11.0857C10.1923 11.2259 10.3784 11.3059 10.5735 11.3076C10.7685 11.3093 10.9561 11.2326 11.0941 11.0947C11.2321 10.9567 11.3088 10.7691 11.307 10.5741C11.3053 10.379 11.2253 10.1929 11.0851 10.0573L9.02832 7.99983L11.0851 5.94242Z" fill="#E6E6E6" />
                                        </svg>
                                    </button>
                                    <button className="mx-2">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_b_844_1156)">
                                                <rect width="24" height="24" rx="2" fill="url(#paint0_linear_844_1156)" />
                                                <rect x="0.741661" y="0.741661" width="22.5167" height="22.5167" rx="1.25834" stroke="url(#paint1_linear_844_1156)" strokeWidth="1.48332" />
                                                <path d="M5.68945 12C6.23808 9.01319 8.8549 6.75 12.0003 6.75C15.1457 6.75 17.7626 9.01319 18.3112 12C17.7626 14.9868 15.1457 17.25 12.0003 17.25C8.8549 17.25 6.23808 14.9868 5.68945 12ZM12.0003 14.9167C13.6112 14.9167 14.917 13.6108 14.917 12C14.917 10.3892 13.6112 9.08333 12.0003 9.08333C10.3895 9.08333 9.08365 10.3892 9.08365 12C9.08365 13.6108 10.3895 14.9167 12.0003 14.9167ZM12.0003 13.75C11.0338 13.75 10.2503 12.9665 10.2503 12C10.2503 11.0335 11.0338 10.25 12.0003 10.25C12.9668 10.25 13.7503 11.0335 13.7503 12C13.7503 12.9665 12.9668 13.75 12.0003 13.75Z" fill="white" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_b_844_1156" x="-29.6664" y="-29.6664" width="83.3328" height="83.3328" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="14.8332" />
                                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_844_1156" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_844_1156" result="shape" />
                                                </filter>
                                                <linearGradient id="paint0_linear_844_1156" x1="0" y1="0" x2="24.008" y2="23.992" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="white" stopOpacity="0.15" />
                                                    <stop offset="1" stopColor="white" stopOpacity="0.02" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_844_1156" x1="23.3333" y1="24" x2="-1.04344" y2="22.8887" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="white" stopOpacity="0.2" />
                                                    <stop offset="1" stopColor="white" stopOpacity="0.1" />
                                                    <stop offset="1" stopColor="white" stopOpacity="0.05" />
                                                </linearGradient>
                                            </defs>
                                        </svg>

                                    </button>
                                    <button>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_b_844_1152)">
                                                <g clipPath="url(#clip0_844_1152)">
                                                    <rect width="24" height="24" rx="2" fill="url(#paint0_linear_844_1152)" />
                                                    <path d="M8.375 7.75001V5.87501C8.375 5.52983 8.65482 5.25001 9 5.25001H14C14.3452 5.25001 14.625 5.52983 14.625 5.87501V7.75001H17.75V9.00001H16.5V17.125C16.5 17.4702 16.2202 17.75 15.875 17.75H7.125C6.77982 17.75 6.5 17.4702 6.5 17.125V9.00001H5.25V7.75001H8.375ZM9.625 6.50001V7.75001H13.375V6.50001H9.625Z" fill="white" />
                                                </g>
                                                <rect x="0.741661" y="0.741661" width="22.5167" height="22.5167" rx="1.25834" stroke="url(#paint1_linear_844_1152)" strokeWidth="1.48332" />
                                            </g>
                                            <defs>
                                                <filter id="filter0_b_844_1152" x="-29.6664" y="-29.6664" width="83.3328" height="83.3328" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="14.8332" />
                                                    <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_844_1152" />
                                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_844_1152" result="shape" />
                                                </filter>
                                                <linearGradient id="paint0_linear_844_1152" x1="0" y1="0" x2="24.008" y2="23.992" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="white" stopOpacity="0.15" />
                                                    <stop offset="1" stopColor="white" stopOpacity="0.02" />
                                                </linearGradient>
                                                <linearGradient id="paint1_linear_844_1152" x1="23.3333" y1="24" x2="-1.04344" y2="22.8887" gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="white" stopOpacity="0.2" />
                                                    <stop offset="1" stopColor="white" stopOpacity="0.1" />
                                                    <stop offset="1" stopColor="white" stopOpacity="0.05" />
                                                </linearGradient>
                                                <clipPath id="clip0_844_1152">
                                                    <rect width="24" height="24" rx="2" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>


                                    </button>
                                </div>
                            </div>
                            <div className="uplodView">
                                <div className="progress">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        style={{ width: `${progress}%` }}
                                        aria-valuenow={progress}
                                    >
                                        {progress}%
                                    </div>
                                </div>
                            </div>
                        </div> */}
                            <div className="col-12 mt-3">
                                <h3 className="text-white">Quick Guide 🔥 </h3>
                                <p style={{ fontSize: 11, color: '#ccc', opacity: '0.3' }}>
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}
export default Upi;